module.exports = "/_next/static/images/4f8dfca6e89920ae87c668f730cce078-digital-account-phone-main-screen@md-2x.png.webp";